import templateStr from 'text!./templates/service-request-history.html';

export default [() => {
    return {
        restrict: 'A',
        template: templateStr,
        scope: {
            history: '='
        },
        link: (scope) => {
            scope.tableConfig = {
                paginationSize: 1000
            };
        }
    };
}];
